import React from 'react';
import {
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { useTags } from '../../tags/tags-provider';
import { TagType } from '../../tags/tags-schema';

interface TagSelectorProps {
  selectedTags: string[];
  onSelectTag: (tagId: string) => void;
  isProduct: boolean;
  label: string;
  placeholder?: string;
}

const TagSelector: React.FC<TagSelectorProps> = ({
  selectedTags,
  onSelectTag,
  isProduct,
  label,
  placeholder = "Select a tag or create new"
}) => {
  const { tags } = useTags();

  const availableTags = tags?.filter((tag: TagType) => 
    !selectedTags.includes(tag.id) && tag.isProduct === isProduct
  ) || [];

  return (
    <IonItem>
      <IonLabel position="stacked">{label}</IonLabel>
      <IonSelect
        placeholder={placeholder}
        onIonChange={e => onSelectTag(e.detail.value)}
        value=""
      >
        {availableTags.map((tag: TagType) => (
          <IonSelectOption key={tag.id} value={tag.id}>
            {tag.displayName}
          </IonSelectOption>
        ))}
        <IonSelectOption value="create-new">Create New Tag...</IonSelectOption>
      </IonSelect>
    </IonItem>
  );
};

export default TagSelector;
